import { render } from "./LoadingScreenWrapper.vue?vue&type=template&id=751206bd&scoped=true"
import script from "./LoadingScreenWrapper.vue?vue&type=script&lang=js"
export * from "./LoadingScreenWrapper.vue?vue&type=script&lang=js"

import "./LoadingScreenWrapper.vue?vue&type=style&index=0&id=751206bd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751206bd"]])

export default __exports__